<!--  -->
<template>
  <div class="child-box">
    <div class="child-head">
      <div class="child-name">气象检测</div>
    </div>
    <div class="content" ref="mycharOne"></div>
    <div class="bottom">
      <div
        :class="item.status == 0 ? 'bottom-item' : 'bottom-item nav'"
        v-for="(item,i) in btndata"
        :key="i"
        @click="check(i)"
      >{{item.name}}</div>
    </div>
  </div>
</template>

<script>
import { optionone } from "../utils/echarts";
import { EleResize } from "../utils/esresize";
export default {
  data() {
    return {
      btndata: [
        {
          name: "气象检测",
          status: 1
        },
        {
          name: "亮度",
          status: 0
        },
        {
          name: "感温光栅温度",
          status: 0
        }
      ]
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.drawLine();
  },

  methods: {
    drawLine() {
      let option = optionone();
      let myChart = this.$echarts.init(this.$refs.mycharOne);
      myChart.setOption(option);
      let listener = function() {
        myChart.resize();
      };
      EleResize.on(this.$refs.mycharOne, listener);
    },
    check(val){
      this.btndata.forEach((item,i) => {
        if(i == val){
          item.status = 1
        }else{
          item.status = 0
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 64%;
  margin-top: 15px;
}
.bottom {
  width: 88%;
  height: 10%;
  display: flex;
  margin-left: 10%;
  margin-top: 3%;
  .bottom-item {
    color: #fff;
    font-size: 10px;
    width: 30%;
    height: 20px;
    background: url(../assets/btn.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    margin-right: 6px;
    cursor: pointer;
  }
  .nav {
    color: #0a6dd0;
  }
}
</style>